export default __webpack_public_path__ + "static/media/harley-quinn.a72a4cd6.png";